module.exports = "img/flags/CF.26f8c8a.png";